import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from "./App";

ReactDOM.render(
    <App/>,
    document.getElementById((window as any)._easy_link_config &&
    (window as any)._easy_link_config.app_dom_root ?
        (window as any)._easy_link_config.app_dom_root : 'root')
);

